import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './CaseStudyDetail.css';
import ContactCTA from '../../components/ContactCTA/ContactCTA';

const CaseStudyDetail = () => {
  const { id } = useParams();

  const caseStudyDetails = {
    'ui-design': {
      title: 'UI/UX Design',
      subtitle: '探索界面设计的艺术，创造直观且美观的用户体验',
      coverImage: '/images/ui.png',
      sections: [
        {
          title: '设计理念',
          content: `作为一名设计师，我深信UI设计不仅是视觉呈现，更是功能的延伸。我的设计哲学以极简著称，但这种简约绝非空洞，而是通过精雕细琢的细节传递直观性和力量。例如，图标设计、系统字体和界面布局都遵循"去繁从简"的原则，确保用户一眼就能理解操作。`
        },
        {
          title: '设计原则',
          content: `我的个人观点是，UI设计的核心在于清晰与直觉。每个按钮、图标和动画都必须有目的性，不能为了美观而牺牲功能。例如，设计一个控制中心的界面时，我会确保每个切换开关（如网络、蓝牙）不仅视觉上整齐划一，还能通过微妙的触觉反馈和动画（如滑动时的弹力感）增强用户操作的愉悦感。同时，我会注重色彩的细微调整——选择柔和的灰色调或品牌标志性的蓝色，这些选择经过用户测试，确保在不同光线和屏幕下保持舒适与可读性。`
        },
        {
          title: '跨设备适配',
          content: `我还会关注跨设备一致性——在不同屏幕尺寸上，UI元素（如按钮大小、字体间距）需要保持一致，但根据设备特性进行优化。例如，小型设备的UI需要更大的触控区域和更直观的图标，因为用户可能在移动或忙碌时操作。我会确保设计不仅美观，还能无缝融入用户使用的生态系统，让他们感到熟悉和信任。`
        },
        {
          title: '核心要点',
          bullets: [
            '用户体验优先：通过大量用户研究和测试，确保设计满足用户需求',
            '视觉统一性：建立了完整的设计系统，确保所有界面元素保持一致',
            '交互细节：精心设计每个交互细节，提升用户体验',
            '性能优化：与开发团队密切合作，确保设计的可实现性'
          ]
        }
      ]
    },
    'comfyui-project': {
      title: 'Comfyui Project',
      subtitle: '深入用户体验设计，打造流畅自然的交互体验',
      coverImage: '/images/comfyui.png',
      sections: [
        {
          title: '项目背景',
          content: `ComfyUI 是一个强大的 AI 创作工具，本项目旨在探索和优化其工作流程，提升创作效率。通过深入研究和实践，我开发了一套完整的工作流程和使用方法。`
        },
        {
          title: '实现方案',
          content: `在这个项目中，我重点关注了工作流程的优化和自动化。通过合理组织节点、设置参数和构建模板，大大提高了创作效率。同时，我也注重了界面的易用性和直观性。`
        },
        {
          title: '技术细节',
          content: `项目使用了多种先进的 AI 模型和技术，包括图像生成、风格迁移和图像处理等。通过精心设计的节点组合，实现了复杂的创作效果。`
        },
        {
          title: '核心特点',
          bullets: [
            '高效的工作流程：通过模板和预设提升效率',
            '灵活的定制选项：支持多种创作风格和效果',
            '优化的用户体验：简化操作流程，降低学习门槛',
            '稳定的输出质量：确保创作结果的一致性'
          ]
        }
      ]
    }
  };

  const study = caseStudyDetails[id];

  if (!study) {
    return <div>Case study not found</div>;
  }

  return (
    <div className="case-study-detail">
      <div className="case-study-container">
        <Link to="/case-studies" className="back-button">
          <span>←</span> 返回案例研究
        </Link>

        <div className="case-study-hero">
          <h1>{study.title}</h1>
          <p className="subtitle">{study.subtitle}</p>
          <img src={study.coverImage} alt={study.title} className="hero-image" />
        </div>

        <div className="case-study-content">
          {study.sections.map((section, index) => (
            <div key={index} className="content-section">
              <h2>{section.title}</h2>
              {section.content && <p>{section.content}</p>}
              {section.bullets && (
                <ul className="bullet-list">
                  {section.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <ContactCTA />
      </div>
    </div>
  );
};

export default CaseStudyDetail; 